import React from 'react';
import { useNavigate } from 'react-router-dom';

import { OFICINA_EXTERNA_FILA } from '../routes';
import '../pages/OficinaExterna.css';

interface Props {
  pendentes: number;
  recusados: number;
  online: boolean;
}

/**
 * A faixa de EXCEÇÃO das telas do inspetor (at-114, ADR 0059): o que ainda está NO APARELHO,
 * esperando para subir — ou o que o servidor recusou.
 *
 * 🔴 **Sem nada pendente ela NÃO É DESENHADA** (25/09/2026, decisão do Victor). Nasceu com um
 * terceiro estado, "Tudo enviado", numa faixa verde de largura inteira — e o estado normal não
 * merece o espaço mais nobre da tela para dizer que não há nada a fazer. Ele virou o
 * `SeloDeEnvio`, no cabeçalho. Os dois estados que sobram mandam o inspetor fazer coisas
 * diferentes e não podem se parecer: "N pendentes" (não desinstale o app nem troque de celular)
 * e "N recusados" (olhe a fila e decida).
 *
 * ⚠️ A data do último download também saiu daqui (é o `CarimboDeDados`): fala do sentido oposto,
 * o que ENTROU no aparelho, e as duas juntas eram lidas como uma só.
 */
const BarraDeSincronizacao: React.FC<Props> = ({ pendentes, recusados, online }) => {
  const navigate = useNavigate();

  if (pendentes === 0 && recusados === 0) return null;

  const classe = recusados > 0 ? 'recusados' : 'pendentes';

  const texto = (): string => {
    if (recusados > 0) {
      return recusados === 1
        ? '1 registro recusado pelo servidor'
        : `${recusados} registros recusados pelo servidor`;
    }
    return pendentes === 1
      ? '1 registro ainda no aparelho, aguardando rede'
      : `${pendentes} registros ainda no aparelho, aguardando rede`;
  };

  return (
    <div className={`oe-barra-sync ${classe}`} role="status">
      <span>{texto()}</span>

      {!online && (
        <span className="oe-offline" title="O aparelho está sem rede. Você pode continuar trabalhando.">
          Sem rede
        </span>
      )}

      <button type="button" onClick={() => navigate(OFICINA_EXTERNA_FILA())}>
        Ver fila
      </button>
    </div>
  );
};

export default BarraDeSincronizacao;
